"use client"

import type React from "react"
import { useState } from "react"
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import { Toaster } from "@packages/web/components/ui/toaster"
import { ConfigProvider } from "@packages/web/components/ConfigProvider"
import RegisterServiceWorker from "@packages/web/components/RegisterServiceWorker"
import { ThemeProvider } from "@packages/web/components/ThemeProvider"

import { buildBackapiUrl, initBackapiUrl } from "@packages/base/utils/fastapi"
import { buildSupabaseUrl, initSupabaseClient } from "@packages/base/utils/supabase"

import * as config from "@/app/config"

const SUPABASE_ANON_KEY = process.env.NEXT_PUBLIC_SUPABASE_ANON_KEY ?? ""
const SUPABASE_URL =
  process.env.NEXT_PUBLIC_SUPABASE_URL ??
  buildSupabaseUrl({ domain: config.DOMAIN, environment: config.ENVIRONMENT, platform: config.PLATFORM })

if (SUPABASE_URL && SUPABASE_ANON_KEY) {
  initSupabaseClient(SUPABASE_URL, SUPABASE_ANON_KEY)
}

initBackapiUrl(buildBackapiUrl({ domain: config.DOMAIN, environment: config.ENVIRONMENT, platform: config.PLATFORM }))

export function Providers({
  children,
  nonce,
}: {
  children: React.ReactNode
  nonce?: string
}) {
  const [queryClient] = useState(() => new QueryClient())
  return (
    <QueryClientProvider client={queryClient}>
      <ConfigProvider value={{...config}}>
        <ThemeProvider 
          attribute="class" 
          defaultTheme="light" 
          enableSystem 
          disableTransitionOnChange
          nonce={nonce}
        >
          <RegisterServiceWorker />
          {children}
          <Toaster />
        </ThemeProvider>
      </ConfigProvider>
    </QueryClientProvider>
  )
}
